import { Box, styled } from '@mui/system';
import { useTranslation } from 'next-i18next';

import { primaryOrange, white } from '@/src/styles/theme/lightThemeOptions';

const Badge = styled(Box)(({ theme }) => ({
    display: 'flex',
    position: 'relative',
    left: '120px',
    right: '40.17%',
    top: '90px',
    bottom: '90.01%',
    padding: '8px 20px',
    background: primaryOrange,
    borderRadius: '12px 12px 12px 0px',
    fontWeight: '700',
    width: 'fit-content',
    fontSize: theme.spacing(3),
    lineHeight: '14px',
    color: white,
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Equip_Bold',
    '@media(max-width: 767px)': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        right: '0',
        position: 'relative',
        left: '92px',
        top: '64px',
        fontSize: theme.spacing(2.5),
        borderRadius: '9px 9px 9px 0px',
        padding: '6px 15px',
    },
}));

interface BadgeProp {
    name: string;
}

export const NameBadge = ({ name }: BadgeProp) => {
    const { t } = useTranslation(['ginger']);
    return (
        <Badge data-testid="badge">
            {t('ginger.asks.nameBadge.welcome.heading', { ns: 'common' })}&nbsp;{' '}
            {name && `${name}!`}{' '}
        </Badge>
    );
};
